import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import type { PaperProps } from '@mui/material/Paper';
import { DisableConsentLinkDialogProps } from './types';

const DisableConsentLinkDialog = ({ open, onClose, onContinue }: DisableConsentLinkDialogProps) => {
  return (
    <Dialog
      aria-describedby="disable-consent-link-dialog-description"
      aria-labelledby="disable-consent-link-dialog-title"
      onClose={onClose}
      open={open}
      slotProps={{
        paper: { 'data-testid': 'disable-consent-confirmation-dialog' } as PaperProps,
      }}
    >
      <DialogTitle id="disable-consent-link-dialog-title">Disable consent link?</DialogTitle>
      <DialogContent>
        <DialogContentText id="disable-consent-link-dialog-description">
          Are you sure you want to disable this candidate&apos;s consent link?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Cancel
        </Button>
        <Button
          color="error"
          onClick={() => {
            onClose();
            onContinue();
          }}
          variant="contained"
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisableConsentLinkDialog;
